import { DataTable, Heading, Loader } from "@/components";
import useUsers from "./useUsers";
import { Button } from "@/components/ui";

const Users = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    propertyOwners,
    isLoadingPropertyOwners,
    propertyDetails,
    onRowClick,
    onCancel
  } = useUsers();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={propertyDetails?.name} />
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingPropertyOwners ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={
              propertyOwners?.data?.sort((a: any, b: any) => {
                if (a.endDate === null && b.endDate !== null) return -1;
                if (a.endDate !== null && b.endDate === null) return 1;
                return 0;
              }) || []
            }
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
          />
          <div className="flex flex-row justify-end gap-3  py-3">
            <Button variant="outline" type="button" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Users;
